import type { Messages } from '../index';

export const components: Messages['components'] = {
  'currency-input': {
    'whole-euro-hint': 'Whole euros only',
  },
  'column-preference': {
    'save-error': 'Columns could not be saved — please try again.',
    menu: {
      trigger: 'Options for column {column}',
      'sort-asc': 'Sort ascending',
      'sort-desc': 'Sort descending',
      'move-left': 'Move left',
      'move-right': 'Move right',
      hide: 'Hide column',
      all: 'All columns …',
    },
    drag: {
      handle: 'Move column {column}',
    },
    trigger: 'Columns',
    panel: {
      title: 'Columns',
      hint: 'Drag to order, the tick switches a column on and off. Applies only to you.',
      'always-visible': 'always visible',
      'new-badge': 'new',
      'new-columns':
        '{count, plural, one {The column {names} is new and sits at the end.} other {The columns {names} are new and sit at the end.}} Put them where you need them.',
      'min-visible': 'At least one column must stay visible.',
      reset: 'Reset to default',
      done: 'Done',
    },
  },
  'access-choice': {
    label: 'Access',
    all: 'All tools',
    'all-hint': 'The client may do everything you may do in immoOS – including tools added later.',
    selected: 'Selected permissions',
    'selected-hint': 'The client may only do what you select here. New tools are not added automatically.',
    'selection-empty': 'Select at least one permission – or allow all tools.',
  },
  'permission-picker': {
    groups: {
      lead: 'Leads',
      deal: 'Deals',
      property: 'Properties',
      activity: 'Activities',
      relationship: 'Contacts & companies',
      valuation: 'Valuations',
      identity: 'Team & locations',
    },
  },
  'select-all-actions': {
    'select-all': 'Select all',
    'deselect-all': 'Deselect all',
  },
  detail: {
    section: {
      add: 'Add',
    },
  },
};
